// pages/student/CourseDetail.js
import {
  Grid,
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Chip,
  Stack,
  Paper,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Rating,
  Avatar,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Home,
  MenuBook,
  ArrowForward,
  School,
  People,
  AccessTime,
  Star,
  PlayCircle,
  CheckCircle,
  Assignment,
  VideoLibrary,
  Description,
  Person,
  Email,
  Phone,
  Share,
  Bookmark,
} from "@mui/icons-material";
import SideBar from "./components/SideBar";
import MD from "../../assets/Courses/MS.png";
import "../../styles/CourseDetail.css";

const CourseDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState(null);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      try {
        const data = JSON.parse(user);
        setUserInfo(data);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const courseData = {
    title: "Microsoft Dynamics 365",
    subtitle: "Master CRM and ERP with Microsoft Dynamics 365",
    level: "Beginner",
    duration: "4 weeks",
    schedule: "Tuesdays and Wednesdays (21:00 - 22:00 UTC)",
    students: 1250,
    rating: 4.8,
    reviews: 342,
    instructor: {
      name: "Esther Howard",
      role: "Python Expert & Dynamics Specialist",
      email: "esther.howard@wavepalmtechub.com",
      phone: "+1 (555) 123-4567",
      avatar: "",
      students: 5000,
      courses: 8,
    },
    description:
      "Welcome to our Microsoft Dynamics 365 Course - your gateway to mastering the powerful suite of business applications designed to transform and streamline your organizational processes.",
    longDescription:
      "Dive into the world of Microsoft Dynamics 365, where you will gain comprehensive insights into Customer Relationship Management (CRM) and Enterprise Resource Planning (ERP) functionalities. Whether you're a business professional seeking to optimize workflows or an IT enthusiast looking to harness the full potential of Dynamics 365, our course offers in-depth modules covering configuration, customization, and integration, empowering you to drive efficiency and innovation within your organization.",
    outline: [
      {
        week: "Week 1",
        title: "Introduction to Microsoft Dynamics 365",
        topics: [
          "Overview of Microsoft Dynamics 365: CRM and ERP",
          "Key features and benefits",
          "Understanding the Dynamics 365 ecosystem",
        ],
      },
      {
        week: "Week 2",
        title: "Dynamics 365 CRM Fundamentals",
        topics: [
          "Customer Engagement in Dynamics 365",
          "Managing leads, opportunities, and accounts",
          "Activities and communication tracking",
        ],
      },
      {
        week: "Week 3",
        title: "Dynamics 365 ERP Fundamentals",
        topics: [
          "Introduction to Dynamics 365 Finance and Operations",
          "Managing financial data and processes",
          "Integrating finance modules with CRM",
        ],
      },
      {
        week: "Week 4",
        title: "Advanced Features and Integration",
        topics: [
          "Advanced customization and configuration",
          "Introduction to Power BI for reporting and analytics",
        ],
      },
    ],
    learningOutcomes: [
      "Master Microsoft Dynamics 365 CRM and ERP modules",
      "Configure and customize Dynamics 365 for business needs",
      "Integrate Dynamics 365 with other Microsoft tools",
      "Optimize business processes using Dynamics 365",
      "Build reports and dashboards using Power BI",
    ],
  };

  const handleEnroll = () => {
    setIsEnrolled(true);
    // Add enrollment logic here
  };

  const handleBookmark = () => {
    setIsBookmarked(!isBookmarked);
  };

  const handleShare = () => {
    // Share logic here
    navigator.clipboard?.writeText(window.location.href);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#F7F8F2",
      }}
    >
      {/* Sidebar */}
      <Box
        sx={{
          width: { xs: 0, md: 280 },
          flexShrink: 0,
          display: { xs: "none", md: "block" },
        }}
      >
        <SideBar />
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            p: { xs: 2, md: 3 },
            backgroundColor: "#ffffff",
            borderBottom: "1px solid rgba(43, 173, 101, 0.06)",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Breadcrumbs
                separator={
                  <ArrowForward
                    sx={{ fontSize: 14, color: "rgba(26,26,26,0.2)" }}
                  />
                }
                aria-label="breadcrumb"
                sx={{ mb: 1 }}
              >
                <Link
                  underline="hover"
                  color="rgba(26, 26, 26, 0.4)"
                  href="/"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: "0.85rem",
                    "&:hover": {
                      color: "#2BAD65",
                    },
                  }}
                >
                  <Home sx={{ fontSize: 16 }} />
                  Home
                </Link>
                <Link
                  underline="hover"
                  color="rgba(26, 26, 26, 0.4)"
                  href="/courses"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: "0.85rem",
                    "&:hover": {
                      color: "#2BAD65",
                    },
                  }}
                >
                  <MenuBook sx={{ fontSize: 16 }} />
                  Courses
                </Link>
                <Typography
                  sx={{
                    color: "#2BAD65",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  {courseData.title}
                </Typography>
              </Breadcrumbs>

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: "#1a1a1a",
                  fontSize: { xs: "1.3rem", md: "2rem" },
                }}
              >
                {courseData.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(26, 26, 26, 0.4)",
                  mt: 0.5,
                }}
              >
                {courseData.subtitle}
              </Typography>
            </Grid>

            <Grid item>
              <Stack direction="row" spacing={1}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<Share />}
                  onClick={handleShare}
                  sx={{
                    color: "rgba(26, 26, 26, 0.4)",
                    borderColor: "rgba(43, 173, 101, 0.1)",
                    "&:hover": {
                      borderColor: "#2BAD65",
                      color: "#2BAD65",
                      backgroundColor: "rgba(43, 173, 101, 0.04)",
                    },
                  }}
                >
                  Share
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<Bookmark />}
                  onClick={handleBookmark}
                  sx={{
                    color: isBookmarked ? "#2BAD65" : "rgba(26, 26, 26, 0.4)",
                    borderColor: isBookmarked
                      ? "#2BAD65"
                      : "rgba(43, 173, 101, 0.1)",
                    backgroundColor: isBookmarked
                      ? "rgba(43, 173, 101, 0.04)"
                      : "transparent",
                    "&:hover": {
                      borderColor: "#2BAD65",
                      color: "#2BAD65",
                      backgroundColor: "rgba(43, 173, 101, 0.04)",
                    },
                  }}
                >
                  {isBookmarked ? "Saved" : "Save"}
                </Button>
                <Chip
                  icon={<School sx={{ fontSize: 16 }} />}
                  label={`${userInfo?.firstname || "Student"}`}
                  sx={{
                    backgroundColor: "rgba(43, 173, 101, 0.08)",
                    color: "#2BAD65",
                    fontWeight: 600,
                    border: "1px solid rgba(43, 173, 101, 0.1)",
                  }}
                />
              </Stack>
            </Grid>
          </Grid>
        </Box>

        {/* Course Content */}
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            p: { xs: 2, md: 3 },
          }}
        >
          <Grid container spacing={3}>
            {/* Main Content */}
            <Grid item xs={12} md={8}>
              {/* Course Image */}
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  mb: 3,
                  border: "1px solid rgba(43, 173, 101, 0.06)",
                }}
              >
                <Box sx={{ position: "relative" }}>
                  <img
                    src={MD}
                    alt={courseData.title}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      p: 3,
                      background:
                        "linear-gradient(transparent, rgba(0,0,0,0.7))",
                    }}
                  >
                    <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                      <Chip
                        label={courseData.level}
                        size="small"
                        sx={{
                          backgroundColor: "rgba(43, 173, 101, 0.9)",
                          color: "#ffffff",
                          fontWeight: 600,
                        }}
                      />
                      <Chip
                        icon={<AccessTime sx={{ fontSize: 14 }} />}
                        label={courseData.duration}
                        size="small"
                        sx={{
                          backgroundColor: "rgba(255, 255, 255, 0.9)",
                          color: "#1a1a1a",
                        }}
                      />
                    </Stack>
                    <Typography
                      variant="h5"
                      sx={{ color: "#ffffff", fontWeight: 700 }}
                    >
                      {courseData.title}
                    </Typography>
                  </Box>
                </Box>
              </Paper>

              {/* Description */}
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  mb: 3,
                  backgroundColor: "#ffffff",
                  border: "1px solid rgba(43, 173, 101, 0.06)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "#1a1a1a", mb: 2 }}
                >
                  About the Course
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(26, 26, 26, 0.6)",
                    lineHeight: 1.8,
                    mb: 2,
                  }}
                >
                  {courseData.longDescription}
                </Typography>
              </Paper>

              {/* Learning Outcomes */}
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  mb: 3,
                  backgroundColor: "#ffffff",
                  border: "1px solid rgba(43, 173, 101, 0.06)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "#1a1a1a", mb: 2 }}
                >
                  What You'll Learn
                </Typography>
                <Grid container spacing={1}>
                  {courseData.learningOutcomes.map((outcome, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <CheckCircle sx={{ color: "#2BAD65", fontSize: 18 }} />
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(26, 26, 26, 0.6)" }}
                        >
                          {outcome}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Paper>

              {/* Course Outline */}
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: "#ffffff",
                  border: "1px solid rgba(43, 173, 101, 0.06)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "#1a1a1a", mb: 2 }}
                >
                  Course Outline
                </Typography>
                {courseData.outline.map((week, index) => (
                  <Box key={index} sx={{ mb: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: "#2BAD65", mb: 1 }}
                    >
                      {week.week}: {week.title}
                    </Typography>
                    <List dense sx={{ pl: 2 }}>
                      {week.topics.map((topic, idx) => (
                        <ListItem key={idx} sx={{ py: 0.5 }}>
                          <ListItemIcon sx={{ minWidth: 30 }}>
                            <CheckCircle
                              sx={{ color: "#A0EF48", fontSize: 16 }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary={topic}
                            primaryTypographyProps={{
                              variant: "body2",
                              sx: { color: "rgba(26, 26, 26, 0.5)" },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                ))}
              </Paper>
            </Grid>

            {/* Sidebar */}
            <Grid item xs={12} md={4}>
              {/* Course Info Card */}
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  mb: 3,
                  backgroundColor: "#ffffff",
                  border: "1px solid rgba(43, 173, 101, 0.06)",
                  position: "sticky",
                  top: 80,
                }}
              >
                {/* Stats */}
                <Stack spacing={2} sx={{ mb: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <People sx={{ color: "rgba(26, 26, 26, 0.3)" }} />
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(26, 26, 26, 0.5)" }}
                    >
                      {courseData.students} students enrolled
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Star sx={{ color: "#FFD93D" }} />
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(26, 26, 26, 0.5)" }}
                    >
                      {courseData.rating} ({courseData.reviews} reviews)
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AccessTime sx={{ color: "rgba(26, 26, 26, 0.3)" }} />
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(26, 26, 26, 0.5)" }}
                    >
                      {courseData.schedule}
                    </Typography>
                  </Box>
                </Stack>

                <Divider
                  sx={{ mb: 3, backgroundColor: "rgba(43, 173, 101, 0.06)" }}
                />

                {/* Instructor Info */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, color: "#1a1a1a", mb: 2 }}
                >
                  Meet the Instructor
                </Typography>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Avatar
                    src={courseData.instructor.avatar}
                    sx={{
                      width: 56,
                      height: 56,
                      backgroundColor: "#2BAD65",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "1.2rem",
                    }}
                  >
                    {courseData.instructor.name.charAt(0)}
                  </Avatar>
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: "#1a1a1a" }}
                    >
                      {courseData.instructor.name}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "rgba(26, 26, 26, 0.4)" }}
                    >
                      {courseData.instructor.role}
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                      <Typography
                        variant="caption"
                        sx={{ color: "rgba(26, 26, 26, 0.3)" }}
                      >
                        {courseData.instructor.students} students
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: "rgba(26, 26, 26, 0.3)" }}
                      >
                        • {courseData.instructor.courses} courses
                      </Typography>
                    </Stack>
                  </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 0.5,
                    }}
                  >
                    <Email
                      sx={{ fontSize: 16, color: "rgba(26, 26, 26, 0.3)" }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ color: "rgba(26, 26, 26, 0.4)" }}
                    >
                      {courseData.instructor.email}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Phone
                      sx={{ fontSize: 16, color: "rgba(26, 26, 26, 0.3)" }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ color: "rgba(26, 26, 26, 0.4)" }}
                    >
                      {courseData.instructor.phone}
                    </Typography>
                  </Box>
                </Box>

                <Divider
                  sx={{ mb: 3, backgroundColor: "rgba(43, 173, 101, 0.06)" }}
                />

                {/* Enroll Button */}
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleEnroll}
                  disabled={isEnrolled}
                  startIcon={isEnrolled ? <CheckCircle /> : <PlayCircle />}
                  sx={{
                    py: 1.5,
                    backgroundColor: isEnrolled ? "#A0EF48" : "#2BAD65",
                    color: isEnrolled ? "#1a1a1a" : "#ffffff",
                    fontWeight: 700,
                    fontSize: "1rem",
                    borderRadius: 2,
                    "&:hover": {
                      backgroundColor: isEnrolled ? "#8EDB40" : "#239A56",
                      transform: "translateY(-2px)",
                      boxShadow: "0 8px 25px rgba(43, 173, 101, 0.3)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  {isEnrolled ? "Enrolled" : "Enroll Now"}
                </Button>

                {!isEnrolled && (
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      textAlign: "center",
                      mt: 1,
                      color: "rgba(26, 26, 26, 0.2)",
                    }}
                  >
                    Join {courseData.students}+ students already enrolled
                  </Typography>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default CourseDetail;
